import i18next from "i18next";
import { Component } from "react";
import { COMPANY_DATE_FORMATS } from "../../constants/Constant";
import { TableManger, TABLES } from "../../managers/TableManger";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import AttendanceSettingApiService from "../../services/AttendanceSettingApiService";
import Utility, { deepClone } from "../../utility/Utility";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { geoLocationMapping, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import AddNewGeoFencingPopup from "./AddNewGeoFencingPopup";
import MapPopup from "./AttendanceMap";
import {
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
    DKIcons,
    DKLabel,
    DKIcon,
    DKSpinner,
    DKTooltipWrapper,
    DKInput,
    Toggle,
    INPUT_TYPE,
    showAlert
} from "deskera-ui-library";
import { LOCATION_NAME_REGEX } from "../../constants/RegexConstants";

export default class LocationMapping extends Component {
    selection
    dateFormat = '';
    addNewGeoLocation = {
        visible:false
    }
    isLocationPopup = {
        visible: false,
        index:-1,
        data:null
    }
    searchString = '';
    searchField = '';
    constructor(props) {

        super(props)
        let dateFormat = COMPANY_DATE_FORMATS.filter(c => c.label == TenantService.get(TENANT.DATE_FORMAT))
        this.dateFormat = dateFormat[0]?.value;
        this.state = {
            grid: {
                gridActions: {
                    filters: [],
                    currentPage: 1,
                    totalPageCount: 1
                },
                gridData: {
                    columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_LOCATION_EMPLOYEE_MAPPING), TABLES.PEOPLE_LOCATION_EMPLOYEE_MAPPING)),
                    rowData: [],
                    filter: [],
                    originalData: []
                },
                canValidate: false
            }
        }

    }
    componentDidMount() {
        this.updateState()
        this.getGeoLocation()
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    onSearch(data) {
        this.searchField = 'name';
        this.searchString = data;
        this.getGeoLocation()
    }
    getAPIConfig( currentPage, searchString, searchField) {
        return {
            params: {
                currentPage: currentPage ,
                limit: 20,
                searchString: searchString,
                searchField: searchField
            },
            queryParams: this.getQueryParams( searchString,searchField)
        }
    }
    getQueryParams( searchString,searchField) {
        const queryParams = {}
        return queryParams;
    }
    getGeoLocation() {

        AttendanceSettingApiService.apiConfig = this.getAPIConfig(this.state.grid.gridActions.currentPage ,this.searchString,this.searchField)
        AttendanceSettingApiService.getAttendanceSettingByPage().then(res=>{
            if(res) {
                let locationIndex = this.state.grid.gridData.columnData.findIndex(col=>col.columnCode==="location");
                if(locationIndex != -1) {
                    this.state.grid.gridData.columnData[locationIndex].options = res.geolocations
                }
                this.setState({
                    grid:{
                        ...this.state.grid,
                        gridData:{
                            ...this.state.grid.gridData,
                            rowData: geoLocationMapping(res.geolocations),
                            columnData: this.state.grid.gridData.columnData
                        },
                        gridActions:{
                            ...this.state.grid.gridActions,
                            currentPage: res.filterConfig? parseInt(res.filterConfig.page):1,
                            totalPageCount: res.filterConfig? parseInt(res.filterConfig.totalPage):1
                        }
                    }
                })
            }
        },error=>{

        })


    }
    onRowAdd() {
        this.addNewGeoLocation.visible = true;
        this.updateState()
    }
    onRowUpdate(data) {

        let fieldIndex = data.rowData.invalidFields.findIndex(f=>f==data.columnKey);
        if(data.columnData.required && Utility.isEmpty(data.rowData[data.columnKey])) {
            if(fieldIndex == -1) {
                data.rowData.invalidFields.push(data.columnKey)
            }
        } else if(data.columnKey == "name"&& !Utility.isEmpty(data.rowData[data.columnKey])) {
            const regex = new RegExp(LOCATION_NAME_REGEX);
            if(!regex.test(data.rowData[data.columnKey])) {
                if(fieldIndex == -1) {
                    data.rowData.invalidFields.push(data.columnKey)
                }
                showToast(i18next.t("LOCATION_NAME_VALID_MSG"),TOAST_TYPE.WARNING)
            } else {
                data.rowData.invalidFields.splice(fieldIndex,1)
            }
        } else if(fieldIndex != -1) {
            data.rowData.invalidFields.splice(fieldIndex,1)
        }
        if(data.rowData.invalidFields && data.rowData.invalidFields.length==0) {
            this.update(data);
        }

    }
    update(data) {

        AttendanceSettingApiService.saveAttendanceSetting(this.prepareForSubmit(data),true).then(res=>{
            this.getGeoLocation()
            showToast(i18next.t("REC_UPDATE_SUCCESS"),TOAST_TYPE.SUCCESS);

        },error=>{
            showToast(i18next.t("REC_UPDATE_FAIL"),TOAST_TYPE.FAILURE);
        })

    }
    prepareForSubmit(data) {
        console.log(data)
        let obj = deepClone(data.rowData);
        obj['id'] = data?.rowData?.data?.id
        delete obj['invalidFields']
        delete obj['data']
        delete obj['selected']
        delete obj['status']
        obj['active'] = (data.rowData['active'] && data.rowData['active'].length != 0 ) ? data.rowData['active'][0]:false
        obj['placeId'] =  data?.rowData?.data?.placeId
        return {geolocations:[obj]}
    }
    onRowDelete (data) {
        showAlert(
            `${i18next.t("DELETE_CONFIRMATION_TITLE")} ?`,
            i18next.t("DELETE_CONFIRMATION_MSG"),
            [
                {title: i18next.t("CANCEL"), className: "bg-gray1 border-m"},
                {title: i18next.t("DELETE"), className: "bg-red text-white ml-r", onClick: () => this.deleteAfterConfirmation(data)}
            ]
        );
    }
    deleteAfterConfirmation(data) {
        let obj = {
            ids:[]
        }
        if(data && data.rowData && data.rowData.data && data.rowData.data.id) {
            obj.ids.push(data.rowData.data.id)
        } else if(data && data.length >0) {
            data.forEach(d=>{
                if(d.data && d.data.id) {
                    obj.ids.push(d.data.id)
                }
            })
        }
        if(obj.ids && obj.ids.length != 0) {
            AttendanceSettingApiService.deleteGeoLocation(obj).then(res=>{
                showToast(i18next.t("REC_DELETED"),TOAST_TYPE.SUCCESS);
                this.getGeoLocation()
            },error=>{
                showToast(i18next.t("RED_FAIL_DELETE"),TOAST_TYPE.FAILURE);
            });
        }
    }
    onContextCancel() {
        this.getGeoLocation()
    }
    onAddNewGeoLocationClose(data) {
        this.addNewGeoLocation.visible = false;
        this.getGeoLocation()
        this.updateState()
    }
    onRowClick(data) {
        console.log(data)
        switch(data.columnData.columnCode) {
            case "address":
            case "latitude":
            case "longitude":
                this.onMapToggle(data);
                break;

        }
    }

    onMapToggle(data) {
        console.log(data)
        if(!this.isLocationPopup.visible) {
            this.isLocationPopup.data = {
                visible:true,
                index:data.rowIndex,
                rowData: {...data.rowData,coordinateList:data.rowData.coordinatesList}
            }
        } else {
            if(this.isLocationPopup?.data?.rowData && data && data.length !=0) {
                let newObj = {
                    ...this.state.grid.gridData.rowData[this.isLocationPopup?.data?.index],
                    address: data[0].address,
                    longitude: data[0].lng?.toString(),
                    latitude: data[0].lat?.toString(),
                    placeId: data[0].placeId,

                    data: {
                        ...this.state.grid.gridData.rowData[this.isLocationPopup?.data?.index].data,
                        address: data[0].address,
                        longitude: data[0].lng?.toString(),
                        latitude: data[0].lat?.toString(),
                        placeId: data[0].placeId,
                    }
                }
                this.update({rowData:newObj})

            } else {
                this.isLocationPopup.data = null;
                this.isLocationPopup.index = null;
            }
        }

        this.toggleVisibleMap();
        this.updateState()
    }
    toggleVisibleMap() {
        this.isLocationPopup.visible = !this.isLocationPopup.visible;
    }
    locationGrid() {
        return (
            <div className="column parent-width flex-1 ">
                <div className="column parent-width mb-s position-relative flex-1 ">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_LOCATION_EMPLOYEE_MAPPING}
                        displayTableName={" "}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={true}
                        showContextEdit={false}
                        isActionEnabled={true}
                        contextMenu={true}
                        isMenuVisible={true}
                        showContextMenu={true}
                        gridData={this.state.grid.gridData}
                        filter={this.state.grid.gridActions.filters}
                        currentPage={this.state.grid.gridActions.currentPage}
                        totalPageCount={this.state.grid.gridActions.totalPageCount}
                        addButtonConfig={[{
                            title: `+ ${i18next.t("ADD_LOCATION")}`,
                            className: "bg-app text-white",
                            onClick: () => { this.onRowAdd() },
                        }]}
                        onRowOpenBtnHidden={true}
                        onFilter={(dataList, queries) => {

                        }}
                        onRowUpdate={(data) => {
                            this.onRowUpdate(data);
                        }}
                        onRowDelete={(data) => {
                            this.onRowDelete(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                            this.state.grid.gridActions.currentPage = requestedPageNumber
                            this.getGeoLocation()
                        }}
                        onSelection={(selection) => {
                            this.selection = (selection);
                        }}
                        isActionEnabled={true}

                        allowBulkOperation={true}
                        dateFormat={this.dateFormat}

                        onCancelContext={() => {
                            this.onContextCancel();
                        }}
                        contextMenu={false}
                        onRowClick={(data)=>{
                            this.onRowClick(data)
                        }}
                        onSearch={(data)=>this.onSearch(data)}
                    />
                </div>
            </div>
        )
    }
    render() {
        return (
            <>
                {this.locationGrid()}
                {this.addNewGeoLocation.visible && <AddNewGeoFencingPopup locationConfig={true} onClose={(data => { this.onAddNewGeoLocationClose(data) })} />}
                {this.isLocationPopup.visible && <MapPopup data={this.isLocationPopup.data} onClose={(data => { this.onMapToggle(data) })} />}
            </>
        )
    }
}